import React, { useEffect, SetStateAction, Dispatch } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faDiscord } from "@fortawesome/free-brands-svg-icons";
import LoadingContent from "../../../components/LoadingContent";
import { countryCodeToFlag } from "../../../utils/Admin";

interface DiscordProps {
  data: any;
  discordTitle: string;
  setDiscordTitle: Dispatch<SetStateAction<string>>;
  discordEmbed: string;
  setDiscordEmbed: Dispatch<SetStateAction<string>>;
  onIndividualSubmit: () => void; // Prop para envío 1 a 1
  uploading: boolean; // Prop para el spinner individual
}

const UploadRaceDiscord = ({
  data,
  discordTitle,
  setDiscordTitle,
  discordEmbed,
  setDiscordEmbed,
  onIndividualSubmit,
  uploading,
}: DiscordProps) => {
  useEffect(() => {
    if (!data || !data.grand_prix) return;

    setDiscordTitle(
      `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} LVF1 ${data.grand_prix.name.toUpperCase()}`,
    );
    setDiscordEmbed(
      [
        "🏆 **Race Results**",
        data.results_link + "\n",
        "",
        "📓 **Standings**",
        `https://ligavirtualf1.es/en/Season/${data.grand_prix.grand_prix.championship.name.replace(/\s+/g, "")}\n`,
        "",
        data.next_gp == null
          ? ""
          : `🔴 **${
              data.grand_prix.grand_prix.championship.type_championship !== 3
                ? "Server Online"
                : "Next Race"
            }**\n${data.next_gp.circuit} · Race · ${data.next_gp.date_converted}`,
      ]
        .filter(Boolean)
        .join("\n"),
    );
  }, [data, setDiscordTitle, setDiscordEmbed]);

  if (data == null) return <LoadingContent />;

  return (
    // Reemplazamos <Form> por un <div> plano para integrarlo en el padre
    <div className="discord-form mb-4 p-3 border rounded shadow-sm">
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            <FontAwesomeIcon
              icon={faDiscord}
              className="me-2"
              style={{ color: "#5865F2" }}
            />
            Discord [including @Role + GP Image]
          </h4>
          <Form.Label>Title (*)</Form.Label>
          <Form.Control
            required
            name="discord_title"
            type="text"
            value={discordTitle}
            onChange={(e) => setDiscordTitle(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="form-group" as={Col} md="12">
          <Form.Label>Embed (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="discord_embed"
            rows={6}
            value={discordEmbed}
            onChange={(e) => setDiscordEmbed(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Field required
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Botón exclusivo para enviar únicamente a Discord */}
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" spin />
        ) : (
          <Button
            type="button" // Evita que se dispare el submit global del componente padre
            variant="secondary"
            onClick={onIndividualSubmit}
          >
            Send Discord Message Only
          </Button>
        )}
      </div>
    </div>
  );
};

export default UploadRaceDiscord;
